"use client";

import { IconDeviceMobile } from "@decibeltrade/react-icons";
import { useTranslations } from "next-intl";
import { useCallback, useEffect, useRef } from "react";
import { css } from "styled-system/css";

import { useAnalyticsRef } from "@/contexts/analytics-context";
import { usePwaInstall } from "@/contexts/pwa-install-context";

import { openPwaInstallModal } from "./modal/pwa-install-modal";
import { TopBanner } from "./top-banner";

const icon = <IconDeviceMobile className={css({ w: "20", h: "20" })} />;

export function PwaInstallBanner() {
  const t = useTranslations("pwaInstall");
  const analyticsRef = useAnalyticsRef();
  const { shouldShow, dismiss } = usePwaInstall();

  const shownRef = useRef(false);
  useEffect(() => {
    if (shouldShow && !shownRef.current) {
      shownRef.current = true;
      analyticsRef.current.pwa.bannerShown();
    }
  }, [shouldShow, analyticsRef]);

  const handleCtaClick = useCallback(() => {
    analyticsRef.current.pwa.bannerCtaClicked();
    openPwaInstallModal();
  }, [analyticsRef]);

  const handleDismissWithAnalytics = useCallback(() => {
    const { snoozeCount, permanent } = dismiss();
    analyticsRef.current.pwa.bannerDismissed({ snoozeCount, permanent });
  }, [dismiss, analyticsRef]);

  if (!shouldShow) return null;

  return (
    <TopBanner
      icon={icon}
      title={t("banner.title")}
      body={t("banner.body")}
      ctas={[{ label: t("banner.cta"), onClick: handleCtaClick }]}
      onDismiss={handleDismissWithAnalytics}
      dismissLabel={t("banner.dismiss")}
      compact
    />
  );
}
